module.exports = __webpack_public_path__ + "img/discount.1e86d949.svg";